<script lang="ts" setup>
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay, Pagination, A11y } from 'swiper/modules'
import { uniqueId } from 'lodash-es'
import { PaginationNormal } from '~/components/common/modules/swiper'
import GoodsImageUrl from '~/components/common/modules/units/goods-image-url.vue'
import { HeadCopyListItem } from '~/api/types/goods'
import { useRouteLink } from '~/composable/utils/use-route-link'

export interface Props {
  items: Array<HeadCopyListItem>
}

const props = withDefaults(defineProps<Props>(), {})

const { goToUrl } = useRouteLink()

const localId = `${uniqueId('__head-copy-banner-')}`

const isSingle = computed(() => {
  if (props.items) {
    return props.items.length <= 1
  } else {
    return false
  }
})
</script>

<template>
  <div :id="localId" class="head-copy-banner-wrap">
    <Swiper
      :modules="[Pagination, Autoplay, A11y]"
      :pagination="{ el: `#${localId} .banner-pagination`, type: 'fraction' }"
      :autoplay="{ delay: 3000, disableOnInteraction: false }"
    >
      <SwiperSlide v-for="(item, index) in items" :key="index">
        <div class="banner-inner" :style="{ 'background-color': item.bckgColor }">
          <a @click="goToUrl(item?.linkUrl)">
            <GoodsImageUrl
              :webp-url="item?.webpCachingPath"
              :image-url="item?.cachingPath"
              :config="{
                alt: item?.hdcpNm
              }"
            />
          </a>
        </div>
      </SwiperSlide>
    </Swiper>

    <PaginationNormal v-if="!isSingle" :use-navigation="false">
      <template #modalContents="{ closeEvent }">
        <ul class="head-copy">
          <li v-for="(item, index) in items" :key="index">
            <div class="banner-inner" :style="{ 'background-color': item.bckgColor }">
              <a @click="goToUrl(item?.linkUrl), closeEvent()">
                <GoodsImageUrl
                  :webp-url="item?.webpCachingPath"
                  :image-url="item?.cachingPath"
                  :config="{
                    alt: item?.hdcpNm
                  }"
                />
              </a>
            </div>
          </li>
        </ul>
      </template>
    </PaginationNormal>
  </div>
</template>
<style lang="scss">
@use '~/pages/goods/scss/head-copy-banner.scss';
</style>
